import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import CloseIcon from 'components/icon/close-icon';
import Image from 'next/image';
import { MLML_LEAD_COOKIE_NAME } from 'constants/cookies';
import Cookies from 'js-cookie';
import { buildClassName } from 'utils/build-class-name';

export interface AgentInfo {
  id: string;
  firstName: string;
  lastName: string;
  photo: string;
}

export default function MyLinkMyLeadBanner({ isFloating = false }) {
  const [isOpen, setIsOpen] = useState(true);
  const closePopover = () => setIsOpen(false);
  const [agentInfo, setAgentInfo] = useState<AgentInfo | null>();
  const agentPic = agentInfo?.photo ? agentInfo?.photo : '/next/assets/images/agent-search/agent-default-profile-pic.png';

  useEffect(() => {
    const checkCookie = () => {
      const cookieValue = Cookies.get(MLML_LEAD_COOKIE_NAME);
      if (cookieValue) {
        setAgentInfo(JSON.parse(cookieValue));
        return true;
      }
      return false;
    };

    const checkCookieWithTimeout = () => {
      if (!checkCookie()) {
        setTimeout(checkCookieWithTimeout, 1000); // Check again after 1 second
      }
    };

    checkCookieWithTimeout();
  }, []);

  return (isOpen && agentInfo?.firstName &&
    <div className={buildClassName(styles.component, isFloating && styles['component-floating'])}>
      {isFloating && <CloseIcon className={styles['close-button']} onClick={closePopover} />}
      <div className={styles['popover-content']}>
        <Image src={agentPic} alt={agentInfo?.firstName} className={styles['avatar-large']} width={60} height={60} />
        <div className={styles['popover-agent-info']}>
          <p className={styles['agent-name']}>You’re viewing this search, courtesy of {agentInfo?.firstName} {agentInfo?.lastName}.</p>
        </div>
      </div>
    </div>
  );
}
